import type {FC} from 'react'
import {useParams} from 'react-router'
import {useMutation, useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {postDeactive, postFreeze} from '../../../../modules/services/member.service'

interface Props {
  data: any
}

const PersonalInfo: FC<Props> = ({data}) => {
  const {id} = useParams<{id: string}>()
  const queryClient = useQueryClient()
  const mutation = useMutation(postFreeze, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getMemberById', id])
      toast.success('Success')
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message)
    },
  })

  const handleStatus = (status: 'freeze' | 'deactivate' | 'active' | 'unfreezed') => {
    mutation.mutate({
      phone: data?.attributes.phone,
      email: data?.attributes.email,
      status: status,
    })
  }
  const isFreezed = data?.attributes.activeStatus === 'freezed'
  const isDeactivated = data?.attributes.activeStatus === 'deactivated'
  return (
    <div className='row'>
      <div className='col d-flex flex-column gap-4'>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Full Name</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.fullname}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Status</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.status}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Persona</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.persona?.data?.attributes?.name || '-'}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Gender</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.gender}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Phone Number</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.phone}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Birthdate</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.birthdate}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Email</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.email}</p>
        </div>
      </div>
      <div className='col d-flex flex-column gap-4'>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Last Transaction</h4>
          {/* issue: relation has one */}
          <p className='fs-6 ms-8'>{data?.attributes?.transactions?.data[data?.attributes?.transactions?.data.length - 1]?.attributes?.TransactionDate || '-'}</p>
        </div>
        <div className='row'>
          <h4 className='fs-6 fw-bold'>Active Status</h4>
          <p className='fs-6 ms-8'>{data?.attributes?.activeStatus}</p>
        </div>
        <div className='row'>
          <div className='d-flex flex-row gap-4'>
            <button
              onClick={() => handleStatus(isFreezed ? 'unfreezed' : 'freeze')}
              className={`btn btn-${isFreezed ? 'primary' : 'info'}`}
            >
              {isFreezed ? 'Unfreeze Account' : 'Freeze Account'}
            </button>
            <button
              onClick={() => handleStatus(isDeactivated ? 'active' : 'deactivate')}
              className={`btn btn-${isDeactivated ? 'primary' : 'danger'}`}
            >
              {isDeactivated ? 'Activate' : 'Deactivate'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PersonalInfo
